// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1bA7Q","label":"SetPasswdForm_label__3PdN1"};